export default __webpack_public_path__ + "static/sparks-dark-05a59d9de3b4493b5217ae22a6e2f392.jpg";